import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useAssignmentViewRecordCreate = () => {
  const setAdminVisibilityControlsAddGroup = useCallback((data) => {
    const requestUrl = `${MONOLITH_ORIGIN}/api/v2/student-assignment-view-record/`;

    const requestConfig = {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(requestUrl, requestConfig);
  }, []);

  return useRestMutation(setAdminVisibilityControlsAddGroup);
};

export default useAssignmentViewRecordCreate;
